// eslint-disable-next-line import/prefer-default-export
export const replacePendingValidationStatusByOrderedStatus = (missions) => missions.map((mission) =>
  mission.status === 'pending_validation' ? { ...mission, status: 'ordered' } : mission);
